import React, { useState } from "react"
import { useAuth } from "../../../auth"
import {
     CONST_CONSULTANT_STATUT_ST_FREELANCE,
     CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE,
     CONST_USER_ROLE_CONSULTANT,
     CONST_USER_ROLE_RESPONSABLE_FOURNISSEUR,
} from "../../../../constants"
import DocumentsPerso from "./DocumentsPerso"
import DocumentsPro from "./pro/DocumentsPro"
import clsx from "clsx"
import { TUTORIAL_TARGET_PROFIL_DOCS_PERSO, TUTORIAL_TARGET_PROFIL_DOCS_PRO } from "../../../../components/tutorial/targets/profile"

export function Documents() {
     const { currentUser } = useAuth()

     const isOngletProAccessible =
          currentUser?.user?.roles?.includes(CONST_USER_ROLE_CONSULTANT) ||
          currentUser?.user?.roles?.includes(CONST_USER_ROLE_RESPONSABLE_FOURNISSEUR) ||
          (currentUser?.user?.roles?.includes(CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE) && currentUser?.consultant?.consultant?.statut === CONST_CONSULTANT_STATUT_ST_FREELANCE)

     const isOngletPersoAccessible = !currentUser?.user?.roles?.includes("ROLE_RESPONSABLE_FOURNISSEUR")

     const [activeOnglet, setActiveOnglet] = useState<"perso" | "pro">(isOngletPersoAccessible ? "perso" : "pro")

     return (
          <div className="card mb-2">
               <div className="card-header card-header-stretch">
                    <div className="card-title m-0">
                         <h3 className="fw-bolder m-0">Documents</h3>
                    </div>
                    <div className="card-toolbar">
                         <ul className="nav nav-tabs nav-line-tabs nav-stretch border-transparent fs-5 fw-bolder" id="kt_security_summary_tabs">
                              {/* Accessible uniquement aux non fournisseur */}
                              {isOngletPersoAccessible && (
                                   <li className={clsx("nav-item cursor-pointer", TUTORIAL_TARGET_PROFIL_DOCS_PERSO)} onClick={() => setActiveOnglet("perso")}>
                                        <span className={`nav-link text-active-primary ${activeOnglet == "perso" && "active"}`}>Perso.</span>
                                   </li>
                              )}
                              {/* Accessible uniquement aux consultants, aux candidats en cours d'embauche pour poste Freelance et aux fournisseurs*/}
                              {isOngletProAccessible && (
                                   <li className={clsx("nav-item cursor-pointer", TUTORIAL_TARGET_PROFIL_DOCS_PRO)} onClick={() => setActiveOnglet("pro")}>
                                        <span className={`nav-link text-active-primary ${activeOnglet == "pro" && "active"}`}>Pro.</span>
                                   </li>
                              )}
                         </ul>
                    </div>
               </div>

               <div className="card-body">
                    {activeOnglet == "perso" && isOngletPersoAccessible && <DocumentsPerso />}
                    {activeOnglet == "pro" && isOngletProAccessible && <DocumentsPro />}
               </div>
          </div>
     )
}
